export const LIBRARY_VERSION = "6.0.17";

export const defaultConfig = {
    apiURL: "https://api.revolt.chat",
    autoReconnect: true,
    heartbeat: 30,
    debug: false,

    cache: false,
    unreads: false,

    ackRateLimiter: true,
};
